jQuery(document).ready(function(){

  /**
   * change_image()
   * @param {string} id
   * @param {object} image
   * @param {string} type
   *
   * Changes the object's src attribute with that from
   * a JSON image description string. This is used to
   * change the featured image in the dropdown.
   */  
  function change_image(id, object, type){
    var fade_speed = 200;
    if (type == "product")
    {
      var url = "//www.thinktankphoto.com/products/" + id + ".js";
      var current = $(object).attr('src');
    }
    else if (type == "collection")
    {
      var url = "//www.thinktankphoto.com/collections/" + id + ".json";
      var current = $(object).attr('src');
    }
    else
    {
      console.log('change_image(id, object, type): type must be "product" or "collection"');
    }

    $.ajax({
      url: url,
      dataType: 'json',
      cache: false,
      success: function (data) {

        if (type == "product" && data['featured_image'])
        {
          var image_url = data['featured_image'].replace('.jpg', '_large.jpg');
        }
        else if (type == "collection" && (data['collection'] && data['collection']['image'] && data['collection']['image']['src'])) {
          var image_url = data['collection']['image']['src'];
        }
        else {
          var image_url = "//placehold.it/480x480&text=" + id;
        }

        if (image_url != current) {
          $(object).stop().animate({opacity:0}, fade_speed, function() {
            $(object).attr('src', image_url);
            $(object).animate({opacity:1}, fade_speed);
          });
        }
      },
      error: function() {
        console.log('Data file for',id,'does not exist.');
      }
    });
  }

  /**
   * add an 'active' class to the main menu item
   * based on the current page
   */
  if ("currentLinkList" in window) {
    $('.main-links > li > span.nav-' + currentLinkList).addClass('current-page');
  }

  // asynchronous preloading
  function preload(sources)
  {
    jQuery.each(sources, function(i,source)
    { 
      jQuery.get(source);
    });
  }

  // build a url for each item that generates an image
  // add that url to a list
  // pass that list to preload()
  i = 1;
  $('.main-links li').not(':first-child').children('span').children('.navbar-dropdown').children('.dropdown-container').children('.collection').not(':last-child').children('.collection-title').each(function(){
    if ($(this).attr('id'))
    {
      i++;
    }
  });

  /** 
   * add the 'active' class to the first 
   * category and first product by default
   * (for the dropdown)
   */
  $('.main-links li').not(':first-child').children('span').children('.navbar-dropdown').children('.dropdown-container').each(function(){

    // make the first collection's first category active
    $(this).children('.collection:first-child').children('.collection-title:first-child').addClass('active-selection');
    
    // make the above category's first product active
    $(this).children('.collection:nth-child(2)').children('div:first-child').children('.product:first-child').addClass('active-selection');
  });

  /**
   * Shows/hides the product list container
   * based on the last-hovered collection-title.
   * Also adds an active class to the collection title to denote
   * the current selection.
   */
  $('.product-list-dropdown .collection-title').hoverIntent(function() {
    var elem = $(this);
    /*
     * add an active class and remove from siblings
     */
    elem.addClass('active-selection')
      .siblings().removeClass('active-selection');
    /*
     * display/hide the correct collection div
     */
    elem.closest('.dropdown-container')
      .find('.dropdown-product-images')
      .each(function() {
        if ($(this).data('id') == elem.data('id')) {
          $(this).removeClass('hidden');
        } else {
          $(this).addClass('hidden');
        }
      });
    /*
     * change the featured image
     */
    var image = elem.closest('.dropdown-container')
      .find('img.category-image');
    var type = '';
    if (elem.data('type') == 'collection_link') {
      type = 'collection';
    } else if (elem.data('type') == 'product_link') {
      type = 'product';
    }
    change_image(elem.data('handle'), image, type);
  }, $.noop);
  
  /**
   * change the featured image in the dropdown
   * whenever a product in the middle column is moused over
   * also: add a class to denote that the link is active
   */
  $('.dropdown-product-images div').hoverIntent(function() {
    var elem = $(this);
    /*
     * remove sibling element's active class, then
     * add an active class.
     */
    elem.addClass('active-selection')
      .siblings().removeClass('active-selection');
    /*
     * change the featured image
     */
    var image = elem.closest('.dropdown-container')
      .find('img.category-image');
    change_image(elem.data('product-handle'), image, "product");
  }, $.noop);

  $('.dropdown-collection-images a').hoverIntent(function(e) {
    var elem = $(this);
    /*
     * remove sibling element's active class, then
     * add an active class.
     */
    elem.addClass('active-selection')
      .siblings().removeClass('active-selection');

    /*
     * change the featured image
     */
    var image = $('.collection-img')[0];
    change_image(elem.data('collection-handle'), image, "collection");
  }, $.noop);

  $(function () {
    var path = window.location.href;
    $('nav a').each(function() {
      if (this.href === path) {
        $(this).addClass('active');
      }
    });
  });

});
